var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgLabs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Multi-tone/Labs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0146 15.9824V39.2353C23.0146 42.334 20.4933 44.8542 17.3946 44.8542C14.2958 44.8542 11.7734 42.334 11.7734 39.2353V15.9824",
    fill: "#BAF6F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.0146 15.9824V39.2353C23.0146 42.334 20.4933 44.8542 17.3946 44.8542C14.2958 44.8542 11.7734 42.334 11.7734 39.2353V15.9824",
    stroke: "#08162D",
    strokeWidth: 1.33
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0107 20.0444V38.6004C21.0107 40.3202 19.849 41.8844 18.1632 42.2299C15.8466 42.704 13.8027 40.9375 13.8027 38.7038V19.7966C13.8027 18.8304 14.6666 18.0722 15.6215 18.2268C16.2092 18.3222 16.6434 18.5098 16.7844 18.5769C17.388 18.8622 18.4963 19.459 19.7228 19.0975C20.3651 18.9088 21.0107 19.3748 21.0107 20.0444Z",
    fill: "#DD5546"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9032 16.3405H22.3298C23.1016 16.3405 23.7314 15.7096 23.7314 14.9389V8.40159C23.7314 7.63089 23.1016 7 22.3298 7H12.4016C11.6297 7 11 7.63089 11 8.40159V14.9389C11 15.7096 11.6297 16.3405 12.4016 16.3405H17.1088",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20.9032 16.3405H22.3298C23.1016 16.3405 23.7314 15.7096 23.7314 14.9389V8.40159C23.7314 7.63089 23.1016 7 22.3298 7H12.4016C11.6297 7 11 7.63089 11 8.40159V14.9389C11 15.7096 11.6297 16.3405 12.4016 16.3405H17.1088",
    stroke: "#08162D",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6591 19.4427V39.1934C39.6591 42.2921 37.1378 44.8122 34.0391 44.8122C30.9404 44.8122 28.418 42.2921 28.418 39.1934V19.4427",
    fill: "#BAF6F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M39.6591 19.4427V39.1934C39.6591 42.2921 37.1378 44.8122 34.0391 44.8122C30.9404 44.8122 28.418 42.2921 28.418 39.1934V19.4427",
    stroke: "#08162D",
    strokeWidth: 1.33
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4492 23.288V38.7043C30.4492 40.4242 31.6121 41.9895 33.2967 42.3339C35.6134 42.8079 37.6572 41.0414 37.6572 38.8077V23.8893C37.6572 22.9231 36.7933 22.1649 35.8385 22.3195C35.2508 22.4138 34.8165 22.6025 34.6767 22.6696C34.072 22.9549 32.9648 22.7026 31.7383 22.3411C31.0949 22.1524 30.4492 22.6184 30.4492 23.288Z",
    fill: "#DD5546"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5536 19.8019H38.9802C39.752 19.8019 40.3818 19.171 40.3818 18.4014V11.7504C40.3818 10.9786 39.752 10.3488 38.9802 10.3488H29.0508C28.2801 10.3488 27.6504 10.9786 27.6504 11.7504V18.4014C27.6504 19.171 28.2801 19.8019 29.0508 19.8019H33.7592",
    fill: "#08162D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M37.5536 19.8019H38.9802C39.752 19.8019 40.3818 19.171 40.3818 18.4014V11.7504C40.3818 10.9786 39.752 10.3488 38.9802 10.3488H29.0508C28.2801 10.3488 27.6504 10.9786 27.6504 11.7504V18.4014C27.6504 19.171 28.2801 19.8019 29.0508 19.8019H33.7592",
    stroke: "#08162D",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1508 9.94911V9.19546C22.1508 9.01699 22.0008 8.86694 21.8223 8.86694H12.8137C12.6352 8.86694 12.4863 9.01699 12.4863 9.19546V10.954C12.4863 11.1313 12.6352 11.2814 12.8137 11.2814C12.8137 11.2814 14.9553 9.94911 22.1508 9.94911Z",
    fill: "#1C2F49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0543 13.3134V12.5586C39.0543 12.3812 38.9042 12.2312 38.7258 12.2312H29.7172C29.5387 12.2312 29.3887 12.3812 29.3887 12.5586V14.3171C29.3887 14.4956 29.5387 14.6445 29.7172 14.6445C29.7172 14.6445 31.8588 13.3134 39.0543 13.3134Z",
    fill: "#1C2F49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8504 37.431H16.7064C15.3685 37.431 14.2852 36.3466 14.2852 35.0098V24.1915C14.2852 23.1082 15.1627 22.2307 16.2449 22.2307H22.8504C23.0232 22.2307 23.163 22.3705 23.163 22.5433V37.1184C23.163 37.2912 23.0232 37.431 22.8504 37.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8504 37.431H16.7064C15.3685 37.431 14.2852 36.3466 14.2852 35.0098V24.1915C14.2852 23.1082 15.1627 22.2307 16.2449 22.2307H22.8504C23.0232 22.2307 23.163 22.3705 23.163 22.5433V37.1184C23.163 37.2912 23.0232 37.431 22.8504 37.431Z",
    stroke: "#08162D",
    strokeWidth: 0.919
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1336 37.5749H32.9896C31.6517 37.5749 30.5684 36.4904 30.5684 35.1536V24.3342C30.5684 23.2521 31.4459 22.3745 32.5281 22.3745H39.1336C39.3064 22.3745 39.4462 22.5143 39.4462 22.6871V37.2623C39.4462 37.4339 39.3064 37.5749 39.1336 37.5749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1336 37.5749H32.9896C31.6517 37.5749 30.5684 36.4904 30.5684 35.1536V24.3342C30.5684 23.2521 31.4459 22.3745 32.5281 22.3745H39.1336C39.3064 22.3745 39.4462 22.5143 39.4462 22.6871V37.2623C39.4462 37.4339 39.3064 37.5749 39.1336 37.5749Z",
    stroke: "#08162D",
    strokeWidth: 0.919
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6309 27.4414H22.6468V24.5723H15.6309V27.4414Z",
    fill: "#7EE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9102 27.4414H38.9249V24.5723H31.9102V27.4414Z",
    fill: "#7EE1E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabs);
export default __webpack_public_path__ + "static/media/Labs.fa9187c4a077dac242735445ce3f7d7a.svg";
export { ForwardRef as ReactComponent };